import { configureStore } from "@reduxjs/toolkit";
import mapReducer from "./pages/map/mapslice"; 

const store = configureStore({
  reducer: {
    map: mapReducer,
  },
});

export default store;
